export enum DeviceType {
  DESKTOP,
  MOBILE,
  IPHONE,
  ANDROID
}
